// extracted by mini-css-extract-plugin
module.exports = {"ModalContent":"AdditionAcivatedModal_ModalContent__lGU2Z","Checkmark":"AdditionAcivatedModal_Checkmark__2ZJ4Z","Button":"AdditionAcivatedModal_Button__154-Y"};